
export const documentFormPaths = {
  '/document-forms': {
    get: {
      summary: 'List all forms or forms for a specific document',
      operationId: 'listDocumentForms',
      tags: ['Document Forms'],
      parameters: [
        {
          name: 'document_id',
          in: 'query',
          schema: {
            type: 'integer',
          },
          description: 'Filter forms by document ID',
        },
      ],
      responses: {
        '200': {
          description: 'A list of document forms',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/DocumentForm',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new document form',
      operationId: 'createDocumentForm',
      tags: ['Document Forms'],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/NewDocumentForm',
            },
            examples: {
              simple: {
                summary: 'Simple form with one step',
                value: {
                  document_id: 1,
                  steps: [
                    {
                      title: "Basic Information",
                      next_step_label: "Continue",
                      sections: [
                        {
                          title: "Applicant Details",
                          section_type: "Default",
                          multiple_elements: false,
                          useful_links: [
                            {
                              label: "Documentation",
                              url: "https://docs.example.com"
                            },
                            {
                              label: "Help Center",
                              url: "https://help.example.com"
                            }
                          ],
                          fields: [
                            {
                              type: "text",
                              label: "Full Name",
                              name: "full_name",
                              filled_by: "Requestor",
                              is_required: true
                            },
                            {
                              type: "select",
                              label: "Applicant Type",
                              name: "applicant_type",
                              filled_by: "Requestor",
                              is_required: true,
                              options: [
                                { value: "owner", label: "Owner" },
                                { value: "tenant", label: "Tenant" }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              }
            }
          },
        },
      },
      responses: {
        '201': {
          description: 'The created document form',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentForm',
              },
            },
          },
        },
        '400': {
          description: 'Invalid request',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
  },
  '/document-forms/{id}': {
    get: {
      summary: 'Get a specific form by ID',
      operationId: 'getDocumentForm',
      tags: ['Document Forms'],
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
          description: 'Document form ID',
        },
      ],
      responses: {
        '200': {
          description: 'The requested document form',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentForm',
              },
            },
          },
        },
        '404': {
          description: 'Form not found',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
    put: {
      summary: 'Update a document form',
      operationId: 'updateDocumentForm',
      tags: ['Document Forms'],
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
          description: 'Document form ID',
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              properties: {
                name: { type: 'string' },
                description: { type: 'string' }
              },
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated document form',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/DocumentForm',
              },
            },
          },
        },
        '404': {
          description: 'Form not found',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a document form',
      operationId: 'deleteDocumentForm',
      tags: ['Document Forms'],
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
          description: 'Document form ID',
        },
      ],
      responses: {
        '204': {
          description: 'Form deleted successfully',
        },
        '404': {
          description: 'Form not found',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
  },
};
